export default __webpack_public_path__ + "static/media/ep_14.0fff650c.png";